module.exports = __webpack_public_path__ + "img/pro-body-photo4.76d304af.png";